import React from "react";
import "../styles/BlogStyles/BlogStyles.css";

const BlogPostDetail4 = () => {
  return (
    <article className="blog-detail-section py-5 bg-light">
      <div className="container bg-white p-0 rounded shadow-sm overflow-hidden content-container">
        
        {/* --- 1. Top Hero Image --- */}
        <div className="w-100">
          <img
            src="https://i.pinimg.com/736x/cc/a4/ed/cca4eddf6eb5ddadb356322404e056f7.jpg"
            alt="Degree Student Success"
            className="img-fluid w-100 object-fit-cover"
            style={{ maxHeight: "470px" }} 
          />
        </div>

        <div className="p-4 p-lg-5">
          {/* --- 2. Main Title --- */}
          <div className="mb-4">
            <h1 className="fw-bold text-purple display-6 mb-3">
              Your Degree + Professional Skills = Career Success | Madhi Academy
            </h1>
          </div>

          {/* --- 3. Introduction --- */}
          <div className="blog-content text-secondary">
            <p className="mb-4 lead fs-6">
              Getting a degree is important. But in today’s world, just a degree is not enough – you need <strong>professional skills</strong> that make you stand out. At <strong>Madhi Academy, Chennai</strong>, we combine <strong>UGC-approved online degree programs</strong> with <strong>career-focused training</strong> to help students graduate with confidence and job readiness.
            </p>

            {/* --- 4. Why Choose Madhi Academy --- */}
            <h4 className="fw-bold text-purple mb-4 mt-5">Why Choose Madhi Academy for Your Degree?</h4>
            <p className="mb-3 fst-italic">Madhi Academy is not just a degree college – it’s your <strong>career partner</strong>. Here’s why students prefer us:</p>
            
            <div className="benefit-list mb-5">
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-laptop text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Flexible Learning</h6><p className="mb-0 small text-muted">Attend UGC-recognised online degree classes without compulsory attendance.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-award text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Dual Qualification</h6><p className="mb-0 small text-muted">Degree + CA / CMA / CS / ACCA coaching in one place.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-wallet2 text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Affordable Fees</h6><p className="mb-0 small text-muted">Installment options available for all programs.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-gear-wide-connected text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Job-Ready Skills</h6><p className="mb-0 small text-muted">Training in Tally, Zoho, GST, Excel, and English communication.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-briefcase-fill text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Placement Assistance</h6><p className="mb-0 small text-muted">Career support after graduation.</p></div>
              </div>
            </div>

            {/* --- 5. Our Degree Programs --- */}
            <h4 className="fw-bold text-purple mb-4">Our Degree Programs</h4>
            
            <div className="mb-4 p-4 bg-light rounded border-start border-4 border-purple">
              <h5 className="fw-bold text-dark">B.Com (Bachelor of Commerce) – Build Your Finance Career</h5>
              <ul className="custom-list small-text mt-3">
                <li>Specialisations: <strong>Accounting & Finance, Corporate Secretaryship, Taxation</strong>.</li>
                <li>3-year UGC-approved program.</li>
                <li>Ideal for students aiming for <strong>CA, CMA, CS, ACCA, CPA</strong>.</li>
              </ul>
            </div>

            <div className="mb-4 p-4 bg-light rounded border-start border-4 border-purple">
              <h5 className="fw-bold text-dark">BBA (Bachelor of Business Administration) – Lead in Business & Management</h5>
              <ul className="custom-list small-text mt-3">
                <li>Focus on <strong>Management, Marketing, and Entrepreneurship</strong>.</li>
                <li>Practical business training with case studies.</li>
                <li>Perfect for students preparing for <strong>MBA or startups</strong>.</li>
              </ul>
            </div>

            <div className="mb-5 p-4 bg-light rounded border-start border-4 border-purple">
              <h5 className="fw-bold text-dark">B.Sc (Computer Science) – Tech + Business Edge (Optional Tie-up)</h5>
              <ul className="custom-list small-text mt-3">
                <li>Covers programming, AI, and business analytics basics.</li>
                <li>Suitable for students aiming for <strong>IT + Business careers</strong>.</li>
              </ul>
            </div>

            {/* --- 6. Add-On Courses --- */}
            <h4 className="fw-bold text-purple mb-3">Add-On Courses for Degree Students</h4>
            <p className="mb-3">Alongside your degree, you gain <strong>career skills</strong> that employers look for:</p>
            <ul className="mb-5 custom-list">
              <li><strong>Professional Courses:</strong> CA, CMA, CS, ACCA coaching.</li>
              <li><strong>Accounting Software:</strong> Tally Prime, Zoho Books, QuickBooks.</li>
              <li><strong>GST & Taxation:</strong> Practical training from industry experts.</li>
              <li><strong>English Communication & Soft Skills:</strong> Confidence for interviews & jobs.</li>
            </ul>

            {/* --- 7. How It Works --- */}
            <h4 className="fw-bold text-purple mb-3">How It Works</h4>
            <div className="row g-2 mb-5 text-center">
              <div className="col-6 col-md-2 mb-3">
                <div className="p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-1-circle-fill text-purple fs-2 mb-2"></i>
                  <small className="fw-bold">Enroll</small>
                </div>
              </div>
              <div className="col-6 col-md-2 mb-3">
                <div className="p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-laptop text-purple fs-2 mb-2"></i>
                  <small className="fw-bold">Online Lectures</small>
                </div>
              </div>
              <div className="col-6 col-md-2 mb-3">
                <div className="p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-people-fill text-purple fs-2 mb-2"></i>
                  <small className="fw-bold">Tuition Support</small>
                </div>
              </div>
              <div className="col-6 col-md-2 mb-3">
                <div className="p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-briefcase text-purple fs-2 mb-2"></i>
                  <small className="fw-bold">Job Skills</small>
                </div>
              </div>
              <div className="col-6 col-md-2 mb-3">
                <div className="p-2 border rounded bg-white h-100 d-flex flex-column justify-content-center align-items-center">
                  <i className="bi bi-mortarboard-fill text-purple fs-2 mb-2"></i>
                  <small className="fw-bold">Graduate</small>
                </div>
              </div>
            </div>

            {/* --- 8. Special Benefits --- */}
            <h4 className="fw-bold text-purple mb-3">Special Benefits at Madhi Academy</h4>
            <ul className="mb-5 custom-list">
              <li>Study from anywhere – online learning support.</li>
              <li>Flexible joining dates – no fixed start schedule.</li>
              <li>Industry connect – guest lectures by corporate professionals.</li>
              <li>100% exam guidance – mock tests, revisions & doubt-clearing.</li>
            </ul>

            {/* --- 9. Success Stories --- */}
            <div className="my-5">
              <h4 className="fw-bold text-purple mb-4">Student Success Stories</h4>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-4 border rounded h-100 bg-white shadow-sm">
                    <p className="small fst-italic mb-2">"I saved 2 years by completing my B.Com + CMA Inter together. Now I’m working in an MNC."</p>
                    <footer className="fw-bold text-purple small">– Priya S.</footer>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-4 border rounded h-100 bg-white shadow-sm">
                    <p className="small fst-italic mb-2">"The best decision I made for my career – Degree + CA Foundation at the same time."</p>
                    <footer className="fw-bold text-purple small">– Rahul K.</footer>
                  </div>
                </div>
              </div>
            </div>

            {/* --- 10. Admissions Open (Footer) --- */}
            <div className="border-top pt-4 mt-5">
              <h4 className="fw-bold text-purple mb-3 text-center">Admissions Open – Apply Now</h4>
              
              <div className="row justify-content-center">
                <div className="col-md-8 text-center bg-light p-3 rounded">
                  <ul className="list-unstyled text-start d-inline-block">
                    <li className="mb-2"><strong className="text-dark">Programs Offered:</strong> B.Com, BBA, B.Sc (CS)</li>
                    <li className="mb-2"><strong className="text-dark">Eligibility:</strong> 12th pass students from any stream</li>
                    <li className="mb-2"><strong className="text-dark">Duration:</strong> 3 years</li>
                    <li className="mb-2"><strong className="text-dark">Mode:</strong> Online + Support from Madhi Academy</li>
                  </ul>
                </div>
              </div>

              <div className="text-center mt-4">
                <a href="tel:+917708941960" className="btn btn-sm btn-purple px-3 me-2 mb-2">
                  <i className="bi bi-telephone-fill me-1"></i> +91 77089 41960
                </a>
                <a href="mailto:admission@madhiacademy.com" className="btn btn-sm btn-purple px-3 mb-2">
                  <i className="bi bi-envelope-fill me-1"></i> admission@madhiacademy.com
                </a>
                <p className="mt-2 small text-muted">
                  <a href="https://degree.madhiacademy.com" className="text-purple text-decoration-none fw-bold">degree.madhiacademy.com</a>
                </p>
                <p className="text-muted small">Madhi Academy – Degree Division, Nammalwarpet, Chennai, India</p>
              </div>
              
              <p className="text-center mt-3 small text-muted fst-italic">
                If you’re searching for the <strong>best online B.Com or BBA in Chennai with CA, CMA, CS, or ACCA coaching</strong>, Madhi Academy is the smart way to learn and succeed.
              </p>
            </div>

          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPostDetail4;